import Component from '../../../../../../../../../lib/component';
import template from './calendar.remind.item.html';
import './calendar.remind.item.scss';
import {CalendarService} from "../../../../../../../../../services/calendar/calendar.service";
import {PMAPI} from "../../../../../../../../../lib/postmsg";
let config = {
    template: template,
    data: {
    },
    binds:[
        {
            event:'click',
            selector:'.fileName',
            callback:function(context,event){
                this.actions.openRemind();
            }
        },
    ],
    actions: {
        /**
         * @author lpf
         * 打开日历提醒
         */
        openRemind: function () {
            let params = {
                table_id: this.data.fileItem.tableId,
                cs_id: this.data.fileItem.setId,
                _id: this.data.fileItem.real_id.substr(2,24)
            };
            let fieldInfos = CalendarService.getFieldInfos();
            CalendarService.getSelectedOpts(params).then(res => {
                let remindDetail = res['data'];
                remindDetail[this.data.fileItem['fieldId']] = this.data.fileItem['fieldValue'];
                let remindDetailData = [];
                for(let field in remindDetail) {
                    let data = {};
                    data['fieldName'] = fieldInfos[field]['dname'];
                    data['fieldValue'] = remindDetail[field];
                    remindDetailData.push(data);
                }
                let config=null;
                if(top.innerWidth <=1400){
                    config=
                        {
                            width: "800",
                            height: '600',
                            title: '查看'
                        }
                }else{
                    config=
                        {
                            width: "1200",
                            height: '640',
                            title: '查看'
                        }
                }
                PMAPI.openDialogByIframe(
                    '/iframe/calendarOpenRemind/',
                    config,{
                        remindTable: this.data.fileItem.tableName,
                        remindDateProp: this.data.fileItem.fieldName,
                        remindDetail: remindDetailData,
                        remindDateTime: this.data.fileItem.time,
                        remindTableId: this.data.fileItem.tableId,
                        remindDate: this.data.fileItem.time.substr(0,10),
                        remindTime: this.data.fileItem.time.substr(11,5),
                        remindRealId: this.data.fileItem.real_id.substr(2,24),
                    }).then(data => {
                    this.data.isTaskClick = false;
                });
            })
        },
    },
    beforeRender(){
    },
    afterRender() {
        console.log('item data', this.data)
        let border = "1px solid "+ this.data.fileItem.color;
        this.el.find('.calendar-remind-item-comment').css({'border':border});
        this.el.find('.triangle-right').css({'background':this.data.fileItem.color});
        let fontSize = this.data.fontSize + 'px';
        //去掉富文本的自带的html标签
        // this.el.find('.fileName').css({'color':this.data.fileItem.color}).html(this.data.fileItem.data3show[0][0].fieldValue);
        this.el.find('.fileName').css({'color':this.data.fileItem.color}).html(this.data.fileName);
    },
    firstAfterRender() {}
};
let CalendarRemindItem = Component.extend(config);

export default CalendarRemindItem;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.item/calendar.remind.item.js